import {Renderer, Component, Input ,Output,EventEmitter,OnInit, AfterViewInit,AfterViewChecked, ViewChild, ElementRef} from '@angular/core';
 import { NgbActiveModal, NgbModal , ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import { callbackify } from 'util';
declare var $ : any;
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import {AppSettings} from '../../../settings';

@Component({
  selector: 'editorzoom',
  templateUrl: './editorzoom.html'
})



export class EditorZoom implements AfterViewInit,OnInit{

  
    
    @Input() content:any;
    toastr:any;

    @Output() passData: EventEmitter<any> = new EventEmitter();
    init:any

    constructor(public activeModal: NgbActiveModal,toastr: ToastrService,){
      this.toastr=toastr;
    }

    ngOnInit(){

      this.init={
        base_url: '/assets',
        width:800,
        height:750,
        nowrap:false,
        importcss_append: true,
        content_css : ['/assets/css/screen.css','/assets/css/developer.css?v=20260916'],
        menubar:false,
        statusbar: false,
        plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks   fullscreen',
        'insertdatetime table paste   help wordcount media','table'
        ],
        extended_valid_elements : 'iframe[src|frameborder|style|scrolling|class|width|height|name|align]',
        image_advtab : true,
        images_upload_handler:this.images_upload_handler,
        toolbar: 'insertfile undo redo| alignleft aligncenter alignright alignjustify | bold italic underline| bullist numlist | image link media | forecolor backcolor | copy mypaste | table styleselect',
        color_map: [
            '000000', 'Black',
            'FFFFFF', 'White',
            'ED0000', 'Red'
            
        ],
        custom_colors: false,
        setup: function (editor) {
          editor.ui.registry.addButton('mypaste', {
            tooltip: 'Paste',
            icon:'paste',
            onAction: ()=> {
              let html=localStorage.getItem('contentcopy')
              if(html!=undefined){
                editor.setContent('')
                editor.insertContent(html);
              }
            },
           
            
          });
          
        },
        style_formats: [
          {title: 'Header styles'},
          {title: 'Article Grey Header', block: 'p', classes:'header1'},
          {title: 'Table styles'},
          {title: 'Full Border Table', selector: 'table', classes: 'table1'},
          {title: 'No Border Table', selector: 'table', classes: 'table2'},
          {title: 'Header Black Table', selector: 'table',classes: 'table3'}
          // {title: 'Table with black capital headeHeader', selector: 'table', classes: 'table4'}
        ],
        content_style:'.table1 {width:100%;border:1px solid #000;}'+
                       '.table1 tr:not(:last-child) td {border-bottom:1px solid #000;}'+
                       '.table1 td:not(:last-child) {border-right:1px solid #000;}'+
                       '.table1 td {padding:15px;}'+'.table1 td:first-child {width:70%;}'+
                       '.table2 {width:100%;border:1px dashed #ccc;}'+
                      '.table2 tr:not(:last-child) td {border-bottom:1px dashed #ccc;}'+
                      '.table2 td:not(:last-child) {border-right:1px dashed #ccc;}'+
                       '.table2 td {padding:15px;}'+
                      '.table2 td:first-child {width:40%;font-weight:900;}'+
                      '.table3 {width:100%;border:1px solid #666;}'+
                      '.table3 tr:not(:last-child) td {border-bottom:1px solid #666;}'+
                      '.table3 td:not(:last-child) {border-right:1px solid #666;}'+
                      '.table3 td {padding:10px;}'+
                      '.table3 th {padding:10px;}'+
                      '.table3 tr:first-child td {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}'+
                      '.table3 th {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}'+
                       '.table4 {width:100%;border:1px solid #666;}'+
                      '.table4 tr:not(:last-child) td {border-bottom:1px solid #666;}'+
                      '.table4 td:not(:last-child) {border-right:1px solid #666;}'+
                      '.table4 td {padding:10px;}'+
                      '.table4 th {padding:10px;}'+
                      '.table4 th {background-color:#000;font-weight:900;color:#fff;text-transform:uppercase;}'+
                      '.table4 tr:first-child td {background-color:#000;font-weight:900;color:#fff;text-transform:uppercase;}'+
                      '.header1 {font-size: 20px !important; padding: 10px 15px; text-transform: uppercase; font-weight: bold; background-image: linear-gradient(to right, #eee, rgba(255,255,255,0));}'
       
       
            
      }
         
    }

    copy(){
     
      let xyz=this.content
      localStorage.setItem('contentcopy',xyz)
      this.toastr.success('Content copied successfully!', '', {timeOut: 3000});
   }

    ngAfterViewInit(): void {

    }

 
    images_upload_handler(blobInfo, success, failure){

      var xhr, formData;

      xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      let url=AppSettings.API_ENDPOINT+'upload.php';

      xhr.open('POST', url);
  
      xhr.onload = function() {
        var json;
  
        if (xhr.status != 200) {
          failure('HTTP Error: ' + xhr.status);
          return;
        }
  
        json = JSON.parse(xhr.responseText);
      
        if (json.status=="error") {
          failure('File upload failed.');
          return;
        }

        // console.log(json.location);
  
        success(AppSettings.API_ENDPOINT+json.files[0].path);
      };
  
      formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());
  
      xhr.send(formData);
    }

    closeZoomModal(){
     
      this.passData.emit(this.content);
      this.activeModal.dismiss('Cross click')
    }

}